<app-header/>

<div class="row expanded goods" [class.block-scroll]="isDarkBackground">

  <div class="cross">
    <a class="close-modal" (click)="closeModal()"></a>
  </div>

  <app-categories-menu
    *ngIf="categoriesSortedDeep && categoriesSortedDeep.length"
    [headCategoryName]="headCategoryName"
    [subHeadCategoryName]="subHeadCategoryName"
    [headCategoryNameColored]="headCategoryNameColored"
    [categoryHeadShow]="categoryHeadShow"
    [has_cards]="has_cards"
    [categoriesSortedDeep]="categoriesSortedDeep"
    [brandsSorted]="brandsSorted"
    [urlParams]="urlParams"
    [calcDebt]="calcDebt"
    (buildCategoriesMenuGoodsData)="buildCategoriesMenuGoodsData()"
    (showModalPaymentRef)="showModalPayment()"
  />

  <div class="column size-head-category">
    <app-navigation-menu
      [selectedUser]="selectedUser"
      [selectedUserAdmin]="selectedUserAdmin"
      [userListAdmin]="userListAdmin"
      [deliveryInfo]="deliveryInfo"
      [deliveryCurrent]="deliveryCurrent"
      [basketSum]="basketSum"
      [basketCount]="basketCount"
      [currencyName]="currencyName"
      [allowLoginUsers]="allowLoginUsers"
      [isAdmin]="isAdmin"
      [wars]="wars"
      [showPartnerWarehouses]="showPartnerWarehouses"
      [urlParams]="urlParams"
      [headCategoryNameColored]="headCategoryNameColored"
      (buildNavigationMenuGoodsData)="buildNavigationMenuGoodsData()"
      (brandMenuShowRef)="brandsMenuShow()"
    />

    <div class="column-title">
      ПОТОЧНИЙ АРТИКУЛ
      <hr>
    </div>
    <div class="row expanded goods-data-table">
      <div class="column scrollable" #scrollableRef>
        <table>
          <thead>
          <tr>
            <th class="adm-th" style="width: 68px" *ngIf="userSupper == 1">pack_id</th>
            <th>Найменування</th>
            <th>Артикул</th>
            <th>Об'єм</th>
            <th>Кільк. шт./л. в уп.</th>
            <th>Умова</th>
            <th class="adm-th" *ngIf="isAdmin && roleId == 0">Кіл-ть</th>
            <th>Склад</th>
            <th class="availability">Наявність</th>
            <th>Ціна</th>
            <th>Кіл-ть</th>
            <th class="added-favorites" style="width: 117px">Додати</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let good of goodsData">
            <ng-container *ngFor="let sup of good.goodsSuppliers">
              <tr class="row-id" *ngIf="sup.count !== null || sup.hasntGood">
                <td class="good-pack-id adm-td" [class.good-name-hide]="!sup.showPackId" *ngIf="userSupper == 1">
                  <div (click)="packIdCopy(good.id)">
                    {{ good.id }}
                  </div>
                </td>
                <td class="bordertop good-mobile" [class.good-name-hide]="!sup.showName">
                  <div class="good-mobile-head">
                    <span class="good-mobile-name">
                      {{ good.name }}
                    </span>
                    <div class="good-mobile-actions">
                      <ng-container *ngIf="good.isset_params === '1'">
                        <div class="good-info" (click)="openGoodInfoModal(good.id)">
                          <label class="question-mark">i</label>
                        </div>
                      </ng-container>

                      <button type="button" *ngIf="sup.showName" class="favorite-button">
                        <i class="fa fa-heart-o favorite-icon"
                           [class.fa-heart]="sup.star"
                           [class.fa-heart-o]="!sup.star"
                           [class.favorite-icon-active]="sup.star"
                           (click)="toggleFavorite(good.name, good.id, sup.star)">
                        </i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="bordertop good-desktop" [class.good-name-hide]="!sup.showName">
                  <span>
                    {{ good.name }}
                    <ng-container *ngIf="good.isset_params === '1'">
                      <div class="good-info" (click)="openGoodInfoModal(good.id)">
                        <label class="question-mark">i</label>
                      </div>
                    </ng-container>
                  </span>
                  <p class="red" *ngIf="good.unbottled == 1">
                    Ціна вказана без урахування тари
                  </p>

                  <button type="button" *ngIf="sup.showName" class="favorite-button">
                    <i class="fa fa-heart-o favorite-icon"
                       [class.fa-heart]="sup.star"
                       [class.fa-heart-o]="!sup.star"
                       [class.favorite-icon-active]="sup.star"
                       (click)="toggleFavorite(good.name, good.id, sup.star)">
                    </i>

                    <span class="favorite-tooltip">Додати в обране</span>
                  </button>
                </td>
                <td [class.good-name-hide]="!sup.showName">
                  <div class="article article-desktop" [class.good-name-hide]="!sup.showName">
                    {{ good.firstArticle }}
                    <div class="prebulb">
                      <label *ngIf="good.lastArticles" (click)="articlesShow()">
                        {{ good.resultLastArticleGood.length }}
                      </label>
                      <div class="bulb" *ngIf="good.lastArticles || isArticlesShow"
                           [class.article-hide]="isArticleHide">
                        <div class="bulbarrow"></div>
                        <span>
                          <div *ngFor="let article of good.lastArticles">
                            {{ article }}
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="article prebulb article-mobile"
                       (click)="articleCopy(good.firstArticle)"
                       [class.good-name-hide]="!sup.showName"
                  >
                    {{ good.firstArticle }}
                    <label *ngIf="good.lastArticles" (click)="articlesShow()">
                      {{ good.resultLastArticleGood.length }}
                    </label>
                    <div class="bulb" *ngIf="good.lastArticles || isArticlesShow "
                         [class.article-hide]="isArticleHide">
                      <div class="bulbarrow"></div>
                      <span>
                          <div *ngFor="let article of good.lastArticles" (click)="articleBulbCopy(article, $event)">
                            {{ article }}
                          </div>
                        </span>
                    </div>
                  </div>
                </td>
                <td>{{ good.litraj }}</td>
                <td>{{ good.cnt_in_pack }}</td>
                <td>
                  <div class="waiting-text" *ngIf="sup.count < 1 && sup.waiting_expect && good.waiting === '1'">
                    Очікуємо {{ sup.waiting_expect }}
                  </div>
                  <ng-container *ngIf="sup.count > 0">
                    <div [innerHTML]="sup.expire"></div>
                  </ng-container>
                  <app-partner-wh-hint [sup]="sup"></app-partner-wh-hint>
                </td>
                <td class="adm-td" *ngIf="isAdmin && roleId == 0">
                  <div>
                    {{ sup.count }}
                  </div>
                </td>

                <td colspan="5" *ngIf="good.inventorization == 1">
                  На інвентаризації
                  <button class="button small" (click)="notifyInventoryFinished(good.id)">
                    повідомити в телеграм бот коли закінчиться інветарізація
                  </button>
                  <button class="button small btn-mobile" (click)="notifyInventoryFinished(good.id)">
                    повідомити в телеграм бот коли закінчиться інветарізація
                  </button>
                </td>

                <td class="label-color" *ngIf="good.inventorization == 0">
                  {{ sup.supplier }}
                  <div class="wh-name" *ngIf="sup.whName">{{ sup.whName }}</div>
                </td>

                <td class="missing-quantity" *ngIf="sup.count  > 9 && good.inventorization == 0">
                  >10
                </td>

                <td class="missing" *ngIf="sup.count  < 1 && good.inventorization == 0">
                  <a class="wait-delivery" (click)="showModalWaitDelivery()">Відсутній</a>
                </td>
                <td class="missing-quantity"
                    *ngIf="sup.count  > 0 && sup.count  < 10 && good.inventorization == 0">
                  {{ sup.count }}
                </td>

                <td disabled *ngIf="good.inventorization == 0">
                  {{ sup.price }} {{ currencyName }}
                </td>

                <td class="count-basket" *ngIf="good.inventorization == 0">
                  <div class="buttons-count-to-basket" *ngIf="sup.count > 0">
                    <span class="minus" (click)="minusCount(sup)">-</span>
                    <span
                      class="number contenteditable"
                      appContenteditable
                      [onlyNumber]="true"
                      [(ngModel)]="sup.countBasket">
                      </span>
                    <span class="plus" (click)="plusCount(sup)">+</span>
                  </div>
                </td>

                <td *ngIf="good.inventorization == 0">
                    <span *ngIf="sup.count > 0"
                          class="missing-quantity-mobile"
                          [class.fire]="sup.turnOn"
                          (click)="addToBasketMobile(good.id, sup, good.name)"

                    >
                      {{ sup.count > 9 ? ">10" : sup.count }} шт.
                    </span>
                  <a [class.add-to-basket]="sup.count > 0"
                     [class.fire]="sup.turnOn"
                     (click)="addToBasket(good.id, sup.countBasket, sup); sup.countBasket = 1">
                  </a>

                  <div class="add-to-favorite" *ngIf="sup.count <= 0 && !sup.hasntGood">
                    <span>Відсутній</span>
                  </div>
                  <span *ngIf="sup.hasntGood">Немає в наявності</span>
                </td>
              </tr>
              <!-- Другие склады партнёра с остатком: раскрываются подсказкой в колонке «Умова» -->
              <ng-container *ngIf="sup.whExpanded && good.inventorization == 0">
                <tr appPartnerWhRow *ngFor="let wh of sup.others"
                    [good]="good" [sup]="sup" [wh]="wh"
                    [userSupper]="userSupper" [isAdmin]="isAdmin" [roleId]="roleId" [currencyName]="currencyName"
                    (add)="addToBasket(good.id, $event.countBasket, $event)"
                    (addMobile)="addToBasketMobile(good.id, $event, good.name)"></tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </table>

        <div *ngIf="isFavoriteMessageShow" class="favorite-message">
          {{ favoriteMessage }}
        </div>

      </div>
    </div>


    <!-- Якір помічника кабінету (#965): блок аналогів - від першого з трьох списків нижче -->
    <div #analogsAnchor *ngIf="originalByBrand.length > 0 || original.length > 0 || analogsGoodsData.length > 0"></div>

    <div *ngIf="originalByBrand.length > 0" class="column-title margin">
      ЗАМІНА АРТИКУЛА ВИРОБНИКОМ
      <hr>
    </div>

    <app-goods-list *ngIf="originalByBrand.length > 0"
                    [goods]="originalByBrand"
                    [currencyName]="currencyName"
                    [isAdmin]="isAdmin"
                    [roleId]="roleId"
                    [userSupper]="userSupper"
                    [partnersNotShowReturnMessage]="partnersNotShowReturnMessage"
                    [activeOrganization]="activeOrganization"
                    [basketData]="basketData"
                    (showModalWaitDeliveryEvent)="showModalWaitDeliveryEvent()"
                    (getBasketAnalogsEvent)="getBasketAnalogsEvent()"
                    (buildAnalogsFavoritesBasket)="buildAnalogsFavoritesBasket()"
    />

    <div *ngIf="original.length > 0" class="column-title margin">
      ПРОПОЗИЦІЇ ПО ОРИГІНАЛЬНИМ ВИРОБНИКАМ
      <hr>
    </div>

    <app-goods-list *ngIf="original.length > 0"
                    [goods]="original"
                    [currencyName]="currencyName"
                    [isAdmin]="isAdmin"
                    [roleId]="roleId"
                    [userSupper]="userSupper"
                    [partnersNotShowReturnMessage]="partnersNotShowReturnMessage"
                    [activeOrganization]="activeOrganization"
                    [basketData]="basketData"
                    (showModalWaitDeliveryEvent)="showModalWaitDeliveryEvent()"
                    (getBasketAnalogsEvent)="getBasketAnalogsEvent()"
                    (buildAnalogsFavoritesBasket)="buildAnalogsFavoritesBasket()"
    />

    <div *ngIf="analogsGoodsData.length > 0" class="column-title margin">
      ПРОПОЗИЦІЇ ЩОДО ЗАМІННИКІВ
      <hr>
    </div>

    <app-goods-list *ngIf="analogsGoodsData.length > 0"
                    [goods]="analogsGoodsData"
                    [currencyName]="currencyName"
                    [isAdmin]="isAdmin"
                    [roleId]="roleId"
                    [userSupper]="userSupper"
                    [partnersNotShowReturnMessage]="partnersNotShowReturnMessage"
                    [activeOrganization]="activeOrganization"
                    [basketData]="basketData"
                    (showModalWaitDeliveryEvent)="showModalWaitDeliveryEvent()"
                    (getBasketAnalogsEvent)="getBasketAnalogsEvent()"
                    (buildAnalogsFavoritesBasket)="buildAnalogsFavoritesBasket()"
    />
    <footer *ngIf="originalByBrand.length > 0 || original.length > 0 || analogsGoodsData.length > 0">
      <small>© 2010-{{ currentYear }}. Всі права захищені.</small>
    </footer>
  </div>
</div>

<footer *ngIf="originalByBrand.length === 0 && original.length === 0 && analogsGoodsData.length === 0">
  <small>© 2010-{{ currentYear }}. Всі права захищені.</small>
</footer>

<div *ngIf="isCopyTextShow" class="success-mess-copy">Текст скопійовано в буфер обміну</div>

<app-modal-good-add-to-basket-mobile [basketModalData]="basketModalData"
                                     (isDarkBackgroundEvent)="isDarkBackgroundAddGoodToBasketModal()"
                                     (getBasket)="getBasketMobile()"/>

<app-modal-good-information/>

<app-modal-non-returnable-items (agreeEvent)="agreeAddToBasket()" (agreeNotShowMoreEvent)="agreeNotShowMore()"/>

